// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sjCMP","clinicsSelect":"styles_clinicsSelect__Yml59"};